import PolylineDecorator from "components/map/shared/polylineDecorator";
import { routeTypesEnum } from "helpers/enums";
import {
    actualLineStyle,
    actualMarkerStyle,
    coordsToSegments,
    emulatedEmptyDashLineStyle,
    emulatedLineStyle,
    factEmptyDashLineStyle,
    factLineStyle,
    factMarkerStyle,
    mobileFactLineStyle,
    mobileMarkerStyle,
    planDashLineStyle,
    planLineStyle,
} from "helpers/map";
import { divIcon } from "leaflet";
import React, { Component, Fragment } from "react";
import { CircleMarker, Marker, Polyline, Tooltip } from "react-leaflet";

const isNotNullArray = (value) => value && value.length && Array.isArray(value);

const RoutePoints = React.memo((props) => {
    const { routePoints, organizationTimezone } = props;
    if (!isNotNullArray(routePoints)) {
        return null;
    }
    return routePoints.map((route, index) => {
        const { points, isMobile, hasActiveMileage } = route;
        const markerStyle = hasActiveMileage ? (isMobile ? mobileMarkerStyle : factMarkerStyle) : actualMarkerStyle;
        if (!isNotNullArray(points)) {
            return null;
        }
        return points.map((point, i) => (
            <RoutePoint
                key={`${index}_${i}`}
                point={point}
                organizationTimezone={organizationTimezone}
                markerStyle={markerStyle}
            />
        ));
    });
});

const RoutePoint = ({ point, organizationTimezone, markerStyle }) => {
    const { fixedAt, coordinate } = point;
    let fixedTime = new Date(fixedAt);
    if (organizationTimezone) {
        fixedTime = fixedTime.toLocaleString("ru-RU", { timeZone: organizationTimezone.id });
    }
    if (!(coordinate && coordinate[0] && coordinate[1])) {
        return null;
    }
    return (
        <CircleMarker center={[coordinate[1], coordinate[0]]} {...markerStyle}>
            <Tooltip className="map__tooltip--default" direction="top">
                {fixedTime}
                {organizationTimezone && (
                    <>
                        <br />
                        {organizationTimezone.displayName}
                    </>
                )}
            </Tooltip>
        </CircleMarker>
    );
};

export default class Route extends Component {
    state = {
        totalRoute: [],
        supportPoints: [],
    };

    componentDidMount() {
        this.initRoute(this.props);
    }

    initRoute = (props) => {
        const { totalRoute, supportPoints, emptyMileageRoute, tollSegments } = coordsToSegments(
            props.route.segments,
            props.route.tollRoadSegments,
        );
        this.setState({ totalRoute, supportPoints, emptyMileageRoute, tollSegments });
    };

    supportPoints = () => {
        const props = {
            icon: divIcon({ className: "route-icon route-icon--between", iconSize: [15, 15] }),
        };
        const { supportPoints } = this.state;
        const pointRenderer = (point, index) => <Marker key={index} position={point} {...props} zIndexOffset={-250} />;

        return supportPoints.map(pointRenderer);
    };

    tollRoads = () =>
        this.state.tollSegments.map((item, i) => (
            <Polyline key={i} positions={item.positions} weight={5} color={item.color} />
        ));

    render() {
        const { traveledRoute, routePoints, organizationTimezone, zoom, filters, expandedRangeTime } = this.props;
        const { mobile, tracker, tollRoads } = filters || {};
        const { totalRoute, emptyMileageRoute } = this.state;
        if (!(totalRoute && totalRoute.length)) {
            return null;
        }
        return (
            <>
                <Polyline positions={emptyMileageRoute} {...planDashLineStyle} />
                <Polyline positions={totalRoute} {...planLineStyle} />
                {tollRoads && this.tollRoads()}
                {traveledRoute &&
                    traveledRoute.map((route, index) => {
                        if (!(route.isMobile ? mobile : tracker)) {
                            return null;
                        }
                        const line =
                            route.hasActiveMileage && !expandedRangeTime
                                ? route.isMobile
                                    ? mobileFactLineStyle
                                    : factLineStyle
                                : actualLineStyle;
                        const lineOptions = {
                            ...line.style,
                            color: line.colors[index % line.colors.length],
                        };
                        return (
                            <Fragment key={index}>
                                <PolylineDecorator positions={route.points[routeTypesEnum.Main]} {...lineOptions} />
                                <PolylineDecorator
                                    positions={route.points[routeTypesEnum.EmptyMileage]}
                                    {...factEmptyDashLineStyle}
                                />
                                {route.emulatedSegments.map((item, i) => (
                                    <PolylineDecorator
                                        key={i}
                                        positions={item.coordinates}
                                        {...(item.routeType = routeTypesEnum.Main
                                            ? emulatedLineStyle
                                            : emulatedEmptyDashLineStyle)}
                                        color={item.id === this.state.selectedEmulatedSegment ? "#904900" : "#c16200"}
                                    />
                                ))}
                            </Fragment>
                        );
                    })}
                {organizationTimezone && organizationTimezone.id && zoom > 7 && (
                    <RoutePoints
                        key={tracker}
                        routePoints={routePoints || []}
                        organizationTimezone={organizationTimezone}
                    />
                )}
                {!this.props.isPreview && this.supportPoints()}
            </>
        );
    }
}
